import { capture } from "./capture";

export const SecurityTracking = {
  /** New mask created. */
  maskCreated: (maskingType: string) => {
    capture("security.mask_created", { masking_type: maskingType });
  },

  /** Existing mask edited. */
  maskEdited: (maskLabel: string, maskingType: string) => {
    capture("security.mask_edited", { mask_label: maskLabel, masking_type: maskingType });
  },

  /** Mask deleted. */
  maskDeleted: (maskLabel: string) => {
    capture("security.mask_deleted", { mask_label: maskLabel });
  },

  /** Mask type changed. */
  maskTypeChanged: (maskLabel: string, newType: string) => {
    capture("security.mask_type_changed", { mask_label: maskLabel, new_type: newType });
  },
};
